import "./App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import HomePage from "./components/_PAGES/0_HomePage/HomePage";
import CategoryPage from "./components/_PAGES/1_CategoryPage/CategoryPage";
import MarketPage from "./components/_PAGES/2_Market/MarketPage";
import ItemPage from "./components/_PAGES/2_Market/_ItemPage/ItemPage";
import Navbar from "./components/Navigation/Navbar";
import Footer from "./components/Informational/Footer";
import { AnimatePresence } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import NavigationContext from "./components/store/navigation-context";
import ContactForm from "./components/UI/ContactForm";
import ReferencesPage from "./components/_PAGES/3_References/ReferencesPage";
import ImageShow from "./components/UI/ImageShow";
import PageLoader from "./components/Other/PageLoader";
import DataContext from "./components/store/data-context";
import ErrorBoundaryFallback from "./components/Other/ErrorBoundaryFallback";

function App() {
  const location = useLocation();
  const navCtx = useContext(NavigationContext);
  const dataCtx = useContext(DataContext);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (
      dataCtx.categories !== -1 &&
      dataCtx.galleries !== -1 &&
      dataCtx.pageData !== -1 &&
      dataCtx.references !== -1
    ) {
      setIsLoaded(true);
    }
  }, [dataCtx.categories, dataCtx.galleries, dataCtx.pageData]);

  return (
    <div className="App">
      {!isLoaded ? (
        <PageLoader />
      ) : (
        <>
          <Navbar />
          {navCtx.isContacting && <ContactForm />}
          {navCtx.showImages.state && <ImageShow />}

          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Navigate to="/hr" />} />

              {/* HOME */}
              <Route path={"/hr"} element={<HomePage />} />
              <Route path={"/de"} element={<HomePage />} />

              {/* MARKET */}
              <Route path={`hr/oglasnik`} element={<MarketPage />}>
                <Route path=":itemSlug" element={<ItemPage />} />
              </Route>
              <Route path={`de/anzeigenmarkt`} element={<MarketPage />}>
                <Route path=":itemSlug" element={<ItemPage />} />
              </Route>

              {/* CATEGORIES */}
              <Route
                path="hr/katalozi/:categorySlug"
                element={<CategoryPage />}
              />
              <Route
                path="de/kataloge/:categorySlug"
                element={<CategoryPage />}
              />

              {/* REFERENCE */}
              <Route path="hr/reference/" element={<ReferencesPage />} />
              <Route path="de/referenzen/" element={<ReferencesPage />} />

              <Route path="/hr/*" element={<Navigate to="/hr" />} />
              <Route path="/de/*" element={<Navigate to="/de" />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </AnimatePresence>
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
